<template>
    <div class="tvlogin">
        <div class="score">
            <div>
                <img class="qrcode" src="@assets/images/tv.png" alt="">
                <div class="title">数据大屏登录确认</div>
            </div>

            <div class="bottomBtn">
                <div class="evaluateBnt bg-color-red" @click="submit">登录</div>
                <div class="cancel" @click="cancel">取消登录</div>
            </div>
        </div>
    </div>
</template>

<script>
import { tvAuth,saveServEvaluate} from "@api/store";
import { trim, VUE_APP_API_URL } from "@utils";
import { required } from "@utils/validate";
import VueCoreImageUpload from "vue-core-image-upload";
import { validatorDefaultCatch } from "@utils/dialog";

const NAME = "TvLogin";

export default {
  name: NAME,
  components: {
    VueCoreImageUpload
  },
  props: {},
  data: function() {
    return {
      deviceid: this.$route.params.id
    };
  },
  mounted: function() {
  },
  watch: {
    $route(n) {}
  },
  methods: {
    async submit() {
      var deviceid = this.deviceid;
      tvAuth({
        deviceid:deviceid,
      }).then(res => {
          this.$dialog.success(res.msg);
          this.$router.replace({
            path: "/tvStatus/1"
          });
        })
        .catch(res => {
          this.$dialog.error(res.msg);
        });
    },
    cancel() {
        this.$router.replace({
            path: "/tvStatus/0"
        });
    }
  }
};
</script>
<style scoped>
.tvlogin .score .item .starsList .iconfont.font-color-yellow {
  color:#F5A623;
}
.tvlogin .score .item .starsList,.tvlogin .score .item .evaluate{
  width:100%;
  margin-bottom: 0.36rem;
}
.tvlogin .score .item .evaluate {
  color: #F5A623;
  font-size: 0.28rem;
}
.tvlogin .score .textarea .list .pictrue.uploadBnt {
  border: 1px solid #ddd;
}
.tvlogin .score {
  text-align: center;
  padding-top: 2.4rem;
}
.tvlogin .score .title {
  color: #1A1A1A;
  font-size: 0.35rem;
  font-weight: 800;
  margin-top: 0.5rem;
}
.tvlogin .score .item .starsList .iconfont {
  font-size: 0.6rem;
}
.tvlogin .score .question {
  text-align: center;
}
.tvlogin .score .question .content
{
  color: #1A1A1A;
  font-weight: 500;
  font-size: 0.28rem;
  margin-bottom: 0.4rem;
  margin-top: 0.44rem;
}
.tvlogin .score .question .evaluateOptions {
  display: flex;
  flex-flow:wrap;
  justify-content: space-around;
}
.tvlogin .score .question .evaluateOptions .options {
  width: 40%;
  border: 1px solid #C8C8C8;
  text-align: center;
  margin: 0.15rem 0;
  padding: 0.13rem 0;
  color: #888888;
}
.tvlogin .score .question .evaluateOptions .options.active
{
  border: 1px solid #e93323;
  color: #e93323;
}

.tvlogin .bottomBtn {
    position: fixed;
    bottom: 2.5rem;
    left: 50%;
    transform: translateX(-50%);
}

.tvlogin .score .evaluateBnt {
    font-size: 0.35rem;
    color: #fff;
    width: 4rem;
    height: 0.86rem;
    border-radius: 0.1rem;
    text-align: center;
    line-height: 0.86rem;
}
.tvlogin .qrcode {
    width: 3.5rem;
}
.tvlogin .cancel {
    margin-top: 0.8rem;
    color: #9e9e9e;
}

</style>
